<template>
  <auth-layout>
    <h1 class="tn-auth__title">Set a new password</h1>
    <p class="tn-auth__subtitle">
      We sent a reset code to <strong>{{ $route.params.email }}</strong>. Enter it below with your new password.
    </p>

    <v-alert v-if="alert" :type="color" text dense class="tn-auth__alert">{{ text }}</v-alert>

    <v-form ref="form" v-model="valid" class="tn-auth__fields" @submit.prevent="reset">
      <label class="tn-field-label" for="reset-code">Reset code</label>
      <v-text-field
        id="reset-code"
        v-model="code"
        type="text"
        outlined
        dense
        hide-details="auto"
        color="gold"
        placeholder="Code from the email"
        prepend-inner-icon="mdi-shield-key-outline"
        :rules="[v => !!v || 'You must enter the reset code', v => v.length >= 4 || 'Code must be more than 4 digits']"
        class="remove-controls tn-auth-field"
        autocomplete="one-time-code"
      ></v-text-field>

      <label class="tn-field-label" for="reset-password">New password</label>
      <v-text-field
        id="reset-password"
        v-model="password"
        :type="show ? 'text' : 'password'"
        outlined
        dense
        hide-details="auto"
        color="gold"
        placeholder="At least 8 characters"
        prepend-inner-icon="mdi-lock-outline"
        :append-icon="show ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
        @click:append="show = !show"
        :rules="[v => !!v || 'Password is required', v => v.length >= 8 || 'Password must be at least 8 characters']"
        autocomplete="new-password"
        class="tn-auth-field"
      ></v-text-field>

      <v-btn type="submit" color="navy" block large depressed class="tn-auth__submit" :loading="loading">
        Update password
        <v-icon right size="18" class="tn-auth__submit-arrow">mdi-arrow-right</v-icon>
      </v-btn>
    </v-form>

    <div class="tn-auth__back">
      <router-link :to="{ name: 'login' }" class="tn-link-btn">
        <v-icon size="16">mdi-arrow-left</v-icon>
        Back to sign in
      </router-link>
    </div>
  </auth-layout>
</template>

<script>
import AuthLayout from '../components/layout/AuthLayout.vue'
import { resetPassword, headersNoAuth } from '../links'

export default {
  title: '-Reset Password',
  components: { AuthLayout },
  data () {
    return {
      valid: true,
      show: false,
      code: '',
      password: '',
      alert: false,
      color: '',
      text: '',
      loading: false
    }
  },
  methods: {
    reset () {
      if (this.loading || !this.$refs.form.validate()) return
      this.loading = true
      const body = {
        token: this.code,
        password: this.password,
        email: this.$route.params.email
      }
      this.$http.post(resetPassword, body, { headers: headersNoAuth() }).then(response => {
        if (response.body.status === false) {
          this.alert = true
          this.color = 'error'
          this.text = response.body.message
          this.loading = false
        } else {
          this.alert = true
          this.color = 'success'
          this.text = 'Your password has been updated, you will be redirected to login'
          this.loading = false
          setTimeout(() => {
            this.$router.push({ name: 'login' })
          }, 3000)
        }
      }, () => {
        this.alert = true
        this.color = 'error'
        this.text = 'Something went wrong please try again in few seconds'
        this.loading = false
      })
    }
  },
  created () {
    if (!this.$route.params.email) this.$router.push({ name: 'Home' })
  }
}
</script>
